import {useEffect} from 'react';

import {
  chatSubscriptionRegistry,
  modelSubscriptionRegistry,
} from './subscriptionRegistry';
import {ModelChangeMessageType} from './types';
import {
  allFieldsMatch,
  allRelatedMatch,
  anyModelMatch,
  anyRelatedMatch,
  modelIdMatch,
  runWhenAll,
  runWhenAllFieldsMatch,
  runWhenAllRelatedMatch,
  runWhenAny,
  runWhenAnyModelMatch,
  runWhenModelIdMatch,
} from './utils';

import {
  AIContentChangeType,
  AIDescriptionChangeType,
  AINameChangeType,
  AIStepAddType,
  AIStepContentChangeType,
  AIStepNameChangeType,
  AIStepRemoveType,
  SuggestionItem,
} from '../openai/types';

const subscriptionUtils = {
  runWhenAll,
  modelIdMatch,
  anyModelMatch,
  allRelatedMatch,
  allFieldsMatch,
  runWhenModelIdMatch,
  runWhenAllFieldsMatch,
  runWhenAnyModelMatch,
  runWhenAllRelatedMatch,
  runWhenAny,
  anyRelatedMatch,
};

export type WSModelChangeMessageHandler = (
  message: ModelChangeMessageType,
  utils: typeof subscriptionUtils
) => unknown;

export function useModelChangeSubscription(
  handler: WSModelChangeMessageHandler,
  inputs: Array<any>
): void {
  useEffect(() => {
    if (window.WebSocket) {
      const localHandler = (message) => handler(message, subscriptionUtils);
      modelSubscriptionRegistry.register(localHandler);
      return () => modelSubscriptionRegistry.unregister(localHandler);
    }
  }, inputs);
}

export type ChatTypes =
  | 'edit_procedure_chat'
  | 'edit_policy_chat'
  | 'edit_text_chat'
  | 'document_suggestions'
  | 'rag'
  | 'ragaccount';

export type WsChatMessage = {
  message: {
    message?: string;
    actions?:
      | Array<SuggestionItem>
      | Array<AINameChangeType | AIContentChangeType>
      | Array<AINameChangeType | AIDescriptionChangeType>;
    step_actions?: Array<AIStepNameChangeType | AIStepContentChangeType>;
    add_actions?: Array<AIStepAddType>;
    remove_actions?: Array<AIStepRemoveType>;
  };
  type: 'error' | 'heartbeat' | 'begin_stream' | 'end_stream' | ChatTypes;
  thread_id?: string;
};

export type WSChatMessageHandler = (
  message: WsChatMessage,
  utils: typeof subscriptionUtils
) => unknown;

export function useChatMessageSubscription(
  handler: WSChatMessageHandler,
  inputs: Array<any>
): void {
  useEffect(() => {
    if (window.WebSocket) {
      const localHandler = (message) => handler(message, subscriptionUtils);
      chatSubscriptionRegistry.register(localHandler);
      return () => chatSubscriptionRegistry.unregister(localHandler);
    }
  }, inputs);
}
